import { get, update } from "@/actions/agreements.action";
import {
  Box,
  Typography,
  Grid,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { AgreementsDto } from "@/data/dtos/agreements.dto";
import InputError from "@/components/core/InputError";

export default function EditAgreement() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { agreement } = useSelector((state: any) => state.agreements);
  const { message } = useSelector((state: any) => state.message);
  const [formValues, setFormValues] = useState<AgreementsDto>(
    agreement || {
      title: "",
      content: "",
      version: 0,
      dynamicFields: { title: "value", title2: "value2" },
    }
  );

  useEffect(() => {
    dispatch(get(id!) as any);
  }, [dispatch, id]);

  useEffect(() => {
    if (!agreement) return;
    const { _id, __v, createdAt, updatedAt, ...filteredAgreement } = agreement;
    setFormValues(filteredAgreement);
  }, [agreement]);

  const [dynamicFieldKey, setDynamicFieldKey] = useState("");
  const [dynamicFieldValue, setDynamicFieldValue] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleEditorChange = (content: string) => {
    setFormValues({ ...formValues, content });
  };

  const handleAddDynamicField = () => {
    if (dynamicFieldKey.trim() && dynamicFieldValue.trim()) {
      setFormValues({
        ...formValues,
        dynamicFields: {
          ...formValues.dynamicFields,
          [dynamicFieldKey]: dynamicFieldValue,
        },
      });
      setDynamicFieldKey("");
      setDynamicFieldValue("");
    }
  };

  const handleDeleteDynamicField = (key: string) => {
    const updatedFields = { ...formValues.dynamicFields };
    delete updatedFields[key];
    setFormValues({ ...formValues, dynamicFields: updatedFields });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    dispatch(update(id!, formValues) as any);
    // Form gönderme işlemi yapılabilir.
  };

  return (
    <div className=" rounded bg-white shadow p-4">
      <Box sx={{ maxWidth: 600, mx: "auto", mt: 4, p: 2, boxShadow: 3 }}>
        <Typography variant="h4" gutterBottom>
          Sözleşme Oluştur
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Title"
                name="title"
                value={formValues.title}
                onChange={handleChange}
                required
              />
              <InputError messages={message?.errors?.title} className="mt-2" />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                İçerik
              </Typography>
              <Editor
                apiKey="8s9qbest1smxmf3nzha41zb1sovfc1id30qz7oqb9m8wt1fi" // TinyMCE API anahtarını buraya ekleyin.
                value={formValues.content}
                init={{
                  height: 300,
                  menubar: false,
                  plugins: ["lists link image table code"],
                  toolbar:
                    "undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code",
                }}
                onEditorChange={handleEditorChange}
              />
              <InputError
                messages={message?.errors?.content}
                className="mt-2"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Version"
                name="version"
                value={formValues.version}
                onChange={handleChange}
                required
                type="number"
              />
              <InputError
                messages={message?.errors?.version}
                className="mt-2"
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Dinamik Alanlar
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <TextField
                    fullWidth
                    label="Field Key"
                    value={dynamicFieldKey}
                    onChange={(e) => setDynamicFieldKey(e.target.value)}
                  />
                </Grid>
                <Grid item xs={5}>
                  <TextField
                    fullWidth
                    label="Field Value"
                    value={dynamicFieldValue}
                    onChange={(e) => setDynamicFieldValue(e.target.value)}
                  />
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    color="primary"
                    onClick={handleAddDynamicField}
                    aria-label="add field"
                  >
                    <AddCircleIcon />
                  </IconButton>
                </Grid>
              </Grid>

              <Box mt={2}>
                {Object.entries(formValues.dynamicFields).map(
                  ([key, value]) => (
                    <Chip
                      key={key}
                      label={`${key}: ${value}`}
                      onDelete={() => handleDeleteDynamicField(key)}
                      deleteIcon={<DeleteIcon />}
                      sx={{ m: 0.5 }}
                    />
                  )
                )}
                <InputError
                  messages={message?.errors?.content}
                  className="mt-2"
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Button type="submit" variant="contained" fullWidth>
                Güncelle
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
}
